import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { FlowInspectResult } from "./model/flow-inspect-result";
import { CrudActionType, HelperFunctions } from "bowman-commons";
import { BowmanCacheService } from "bowman-cache";
import { UserResponse } from "algorilla-shared-libs";
import { NotificationsService } from "bowman-angular2-notifications";
import { SearchResultProperty } from "../model/search-result-property";
import { EventDetailDialog } from "src/app/event-details-tray/model/event-detail-dialog";
import { SearchFilter } from "../model/search-filter";
import { DashboardBusService } from "src/app/event-details-tray/service/dashboard-bus-service";
import { QueryManagerService } from "src/app/services/query-manager.service";
import { SearchRequestDto, SortTypeEnum } from "src/app/shared/search-request-dto";
import { SearchRequestNg } from "../model/search-request-ng";
import { TimeRange } from "../model/time-range";
import { Common } from "../common";
import { SearchOptions } from "../model/search-options";
import { DataLineageDefinition, DataLineageSearchResult } from "./model/data-lineage-search-result";
import { StepType } from "src/app/data-types/flow-management/model/step-type";
import { Subscription } from "rxjs";
import { TypeMappingComponent } from "src/app/data-types/type-mapping/type-mapping.component";
import { FieldMapping } from "../model/field-mapping";

@Component({
  selector: 'app-flow-inspect-table-event-details',
  templateUrl: './flow-inspect-table-event-details.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FlowInspectTableEventDetailsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() content: FlowInspectResult;
  public crudActionTypes = CrudActionType;
  public action = this.crudActionTypes.TEST;
  public matchedClosureSteps: string[] = [];
  public user: UserResponse;
  public dataLineageResults: any[] = [];
  public dataLineageMap: Record<string, DataLineageSearchResult> = {};
  public dataLineageIsLoading: boolean = false;
  public rawInspectData: Record<string, number> = {};
  public fieldMappings: { [name: string]: FieldMapping } = {};
  public timestampFields: { [name: string]: FieldMapping } = {};
  public initialized: boolean = false;
  constructor(
    private _bowmanCacheService: BowmanCacheService,
    private _notificationsService: NotificationsService,
    private _queryService: QueryManagerService,
    private _dashboardBusService: DashboardBusService,
    private _cdr: ChangeDetectorRef

  ) { }

  ngOnInit(): void {
    if (this._bowmanCacheService.has('algorilla_user')) {
      this._bowmanCacheService.get('algorilla_user').subscribe(user => {
        this.user = user;
        TypeMappingComponent.getFieldsMapping(this._bowmanCacheService, this._queryService).subscribe(fieldsMapping => {
          this.fieldMappings = fieldsMapping;
          let stepCodes: string[] = [];
          if (this.content && this.content.drawFlowData && this.content.drawFlowData.drawFlowData) {
            Object.keys(this.content.drawFlowData.drawFlowData).map(stepId => {
              stepCodes.push(this.content.drawFlowData.drawFlowData[stepId].data.code);
            })
          }

          if (this.content && this.content.searchResultProperties) {
            // Cerca matchedClosureId
            this.content.searchResultProperties.map(srp => {
              if (stepCodes.length > 0) {
                stepCodes.map(stepCode => {
                  if (srp.key == `${stepCode}_ts`) {
                    this.rawInspectData[stepCode] = srp.value;
                  }
                });
              }

              if (srp.key == 'matchedClosureId') {
                this.content.drawFlowData.closures.map(closure => {
                  if (closure.name == srp.value) {
                    this.matchedClosureSteps = closure.stepTypeCodes;
                  }
                })
              }
            });
          }
          if (this.content && this.content.visibleFieldsLabel) {
            this.content.visibleFieldsMapping = Object.keys(this.content.visibleFieldsLabel);
          }
          this.initialized = true;
        });
      });
    } else {
      this.user = null;
      this._notificationsService.error('Cannot get user information');
    }
  }
  public getStepNameByCode(stepCode: string): string {
    let result: string = stepCode;
    if (this.content && this.content.drawFlowData && this.content.drawFlowData.drawFlowData && this.content.drawFlowData.drawFlowData) {
      Object.keys(this.content.drawFlowData.drawFlowData).map(stepId => {
        if (stepCode == this.content.drawFlowData.drawFlowData[stepId].data.code) {
          result = this.content.drawFlowData.drawFlowData[stepId].data.name;
        }
      });
    }
    return result;
  }

  getDataLineage(flowInstanceId: string): void {
    let searchRequest: SearchRequestNg = new SearchRequestNg();
    let startTime: number = this.getProperty('start_ts', this.content.searchResultProperties).value;
    let endTime: number = this.getProperty('end_ts', this.content.searchResultProperties).value != null ? this.getProperty('end_ts', this.content.searchResultProperties).value : new Date().getTime();
    if (flowInstanceId != null && flowInstanceId.trim() != '' && startTime && startTime != null && endTime && endTime != null && this.content.dataLineageTypeMapping && this.content.dataLineageTypeMapping.length > 0) {
      let searchOptions: SearchOptions = new SearchOptions();
      searchOptions.size = 100;
      searchRequest.queryString = `flowInstanceId: "${flowInstanceId}" OR flowinstanceid: "${flowInstanceId}"`;
      searchRequest.timeRange = new TimeRange(new Date(startTime - 30000), new Date(endTime + 30000));
      searchRequest.typeMapping = this.content.dataLineageTypeMapping;
      let parsedSearchRequest: SearchRequestDto = Common.marshallSearchRequest(searchRequest, searchOptions, HelperFunctions.uuid());
      let lineageResults: DataLineageSearchResult[] = [];
      let lineageProcessingIdResults: DataLineageSearchResult[] = [];
      let lineageProcessingIds: string[] = [];
      this.dataLineageIsLoading = true;
      this._queryService.search(parsedSearchRequest).subscribe(res => {
        if (res && res.result && res.result.numResults > 0) {
          res.result.searchResults.map(sr => {
            lineageResults.push(new DataLineageSearchResult(sr.searchResultProperties));
          });
        }
        if (lineageResults.length > 0) {
          lineageProcessingIds = [...new Set(lineageResults.map(lr => lr.dataLineageProcessingId))];
        }
        if (lineageProcessingIds.length > 0) {
          lineageProcessingIds.map(lineageProcessingId => {
            let lineageProcessingIdSearchRequest: SearchRequestNg = new SearchRequestNg();
            lineageProcessingIdSearchRequest.queryString = `flowInstanceId: heartbeat AND lineage: ${lineageProcessingId}`;
            lineageProcessingIdSearchRequest.timeRange = new TimeRange(new Date(startTime - 30000), new Date(endTime + 30000));
            lineageProcessingIdSearchRequest.typeMapping = this.content.dataLineageTypeMapping;
            let lineageParsedSearchRequest: SearchRequestDto = Common.marshallSearchRequest(lineageProcessingIdSearchRequest, searchOptions, HelperFunctions.uuid());
            this._queryService.search(lineageParsedSearchRequest).subscribe(lineageProcessingIdRes => {
              if (lineageProcessingIdRes && lineageProcessingIdRes.result && lineageProcessingIdRes.result.numResults > 0) {
                lineageProcessingIdRes.result.searchResults.map(lineageSearchResult => {
                  lineageProcessingIdResults.push(new DataLineageSearchResult(lineageSearchResult.searchResultProperties));
                });
                if (this.content && this.content.drawFlowData && this.content.drawFlowData.drawFlowData) {
                  Object.keys(this.content.drawFlowData.drawFlowData).map(stepId => {
                    let stepData: StepType = this.content.drawFlowData.drawFlowData[stepId].data;

                    try {
                      if (!this.dataLineageMap[stepData.code]) {
                        let stepDataLineageResult: DataLineageSearchResult = lineageResults.filter(lineageResult => lineageResult.stepTypeCode == stepData.code)[0];
                        if (stepDataLineageResult) {
                          this.dataLineageMap[stepData.code] = stepDataLineageResult;
                          if (stepData.lineage) {
                            let dlDefinition: DataLineageDefinition = new DataLineageDefinition();
                            dlDefinition.type = stepData.lineage.sourceType;
                            dlDefinition.dataLineageFields = JSON.parse(stepData.lineage.jsonData);
                            this.dataLineageMap[stepData.code].dataLineageDefinition = dlDefinition;
                          }
                          this.dataLineageMap[stepData.code].dataLineageProcessingIdResult = lineageProcessingIdResults.filter(lineageProcessingIdResult => lineageProcessingIdResult.dataLineageProcessingId == stepDataLineageResult.dataLineageProcessingId)[0];
                        } else {
                          this.dataLineageMap[stepData.code] = new DataLineageSearchResult();
                        }
                      }
                    } catch (dlParseErr) {
                      this._notificationsService.error(`Unable to get parse Data Lineage data for the selected Flow Instance`);
                      this.dataLineageIsLoading = false;
                      this._cdr.detectChanges();
                    }
                  });
                }
                this.dataLineageIsLoading = false;
                this._cdr.detectChanges();
              }
            }, lineageProcessingIdErr => {
              this._notificationsService.error(`Unable to get Data Lineage for the selected Flow Instance`);
              this.dataLineageIsLoading = false;
              this._cdr.detectChanges();
            });
          });


        } else {
          this.dataLineageIsLoading = false;
          this._cdr.detectChanges();
        }

      }, err => {
        this._notificationsService.error(`Unable to get Data Lineage for the selected Flow Instance`);
        this.dataLineageIsLoading = false;
        this._cdr.detectChanges();
      })
    } else {
      this._notificationsService.error(`Unable to get Data Lineage for the selected Flow Instance`);
      this.dataLineageIsLoading = false;
      this._cdr.detectChanges();
    }
  }
  public isDataLineagePresentForStepCode(stepCode: string): boolean {
    return (typeof this.dataLineageMap != 'undefined' && typeof this.dataLineageMap[stepCode] != 'undefined' && Object.keys(this.dataLineageMap[stepCode].dataLineageFields).length > 0);
  }
  public getProperty(propertyName: string, searchResultProperties: SearchResultProperty[]): SearchResultProperty {
    if (searchResultProperties.find(p => p.key == propertyName)) {
      return searchResultProperties.find(p => p.key == propertyName)
    } else {
      return new SearchResultProperty(propertyName, null);
    }
  }

  public setQueryString(event: any) {
    let queryString: string = null;
    if (event && event.item && event.item.selectedValue != null) {
      if (event.item.selectedKey != null) {
        queryString = event.item.selectedKey + ': "' + event.item.selectedValue + '"';
      } else {
        queryString = '"' + event.item.selectedValue + '"';
      }
    } else {
      queryString = event;
    }

    let searchFilter: SearchFilter = new SearchFilter();
    searchFilter.value = queryString;
    this._dashboardBusService.pushFilter(null, searchFilter);
    this._dashboardBusService.doSearch();
  }

  ngOnDestroy(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

}
